import Vue from 'vue'
import Vuex from 'vuex'
import video from './video'
import share from './share'
import follow from './follow'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    video,
    share,
    follow,
    user
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js